module.exports = __webpack_public_path__ + "assets/135953374096655b9f1bb959db83e7f4.png";